exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fm-modal-audio-player .fas.fa-play {\n  color: gray;\n  opacity: 0.1;\n  cursor: pointer;\n}\n.fm-modal-audio-player .fas.fa-play:hover {\n  opacity: 0.5;\n}\n.fm-modal-audio-player .fas.fa-play.active {\n  opacity: 1;\n  color: deepskyblue;\n}\n.fm-modal-audio-player .fas.fa-pause {\n  color: gray;\n  opacity: 0.5;\n  cursor: pointer;\n}", ""]);

// exports
